import React, { useRef } from "react";
import SvgSecurite from "../../_svg/Securite";
import { withTranslation } from 'react-i18next';

const App = (props) => {
  const ref = useRef();
  const { t } = props
  const content = {
    title: t('applications.saphir.security'),
    description: t('applications.saphir.security.description')
  }
  return (
              <div className={"svg-container"} id={"svg-securite-saphir"} itemScope itemType="https://schema.org/WebPage">
                <div>
                  <SvgSecurite fill={"#b77830"} />
                  <h3 itemProp="alternativeHeadline">{content.title}</h3>
                  <span itemProp="description">
                    {content.description}
                  </span>
                </div>
              </div>
  );
};

const tr = withTranslation()(App);
export default tr;
